import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import App from "../App";
import Activate from "../auth/Activate";
import Profile from "../core/Profile";
import Test from "../core/Test";
import PrivateRoute from "../auth/PrivateRoute";
import Forgot from "../auth/Forgot";
import Reset from "../auth/Reset";
import Forbidden from "../auth/Forbidden";
import UserRoles from "../auth/UserRoles";
import WelcomeSeller from "../BuyerSellerStack/SellerStack/seller-views/WelcomeSeller.js";
import LandingPageSeller from "../BuyerSellerStack/SellerStack/components/LandingPageSeller";
import Signin from "../views/Signin/Signin";
import Support from "../views/Support/Support";
import Partner from "../BuyerSellerStack/SellerStack/Partner.js";
import NotificationsPage from "../BuyerSellerStack/SellerStack/Notifications-page.js";
import HomePage from "../BuyerSellerStack/SellerStack/Home-page.js";
import Store from "../BuyerSellerStack/SellerStack/Store.js";
import RequestPage from "../BuyerSellerStack/SellerStack/RequestPage.js"
import MessagesPage from "../BuyerSellerStack/SellerStack/Messages-page.js";
import OfferPage from "../BuyerSellerStack/SellerStack/OfferPage.js";
import CreateOfferPage from "../BuyerSellerStack/SellerStack/Create-offer-page.js";
import OfferReview from "../BuyerSellerStack/SellerStack/components/OfferReviewComponents/OfferReview.js";
import Addresses from "../BuyerSellerStack/SellerStack/Addresses.js";
import CreateAddressPage from "../BuyerSellerStack/SellerStack/Create-address-page.js";

const AppRoutes = () => {
    return (
        <Routes>
            {/* Seller Routes */}
            <Route
                path="/"
                element={
                    <LandingPageSeller />
                }
            />
            <Route path="/support" element={<Support />} />
            <Route path="/home" element={<Partner />} />
            <Route path="/home-page" element={<HomePage />} />
            <Route path="/notifications" element={<NotificationsPage />} />
            <Route path="/create-offer" element={<CreateOfferPage />} />
            <Route path="/messages" element={<MessagesPage />} />
            <Route path="/store" element={<Store />} />
            <Route path="/request" element={<RequestPage />} />
            <Route path="/offers" element={<OfferPage />} />
            <Route path="/offer-review" element={<OfferReview />} />
            <Route path="/addresses" element={<Addresses />} />
            <Route path="/create-address" element={<CreateAddressPage />} />



            <Route path="/signin" element={<Signin />} />
            <Route
                path="/welcome"
                element={
                    <PrivateRoute roles={[UserRoles.ADMIN, UserRoles.SELLER]}>
                        <WelcomeSeller />
                    </PrivateRoute>
                }
            />

            {/* Other Routes */}
            <Route path="/auth/activate/:token" element={<Activate />} />
            <Route
                path="/profile"
                element={
                    <PrivateRoute>
                        <Profile />
                    </PrivateRoute>
                }
            />
            <Route path="/auth/password/forgot" element={<Forgot />} />
            <Route path="/auth/password/reset/:token" element={<Reset />} />
            <Route path="/makes" element={<App />} />
            <Route path="/forbidden" element={<Forbidden />} />
        </Routes>
    );
};

export default AppRoutes;
